import { useEffect, useState } from "react";

import { Chart } from "primereact/chart";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";

import ChartDataLabels from "chartjs-plugin-datalabels";

import { useReport } from "../../../context/report";

import "./styles.css";

const options = {
    borderWidth: 1,
    width: 100 / 12 + "%"
}

export function TesteGoma() {
    const { data } = useReport();

    const [chartData, setChartData] = useState({});

    const chartOptions = {
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: "GRÁFICO MÉDIA DE QUEBRAS",
                font: {
                    size: 18
                }
            },
            datalabels: {
                font: {
                    size: 24
                },
                color: "#000",
                formatter: (value) => {
                    return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
                }
            }
        }
    }

    const rowColor = (data) => {
        return {
            'teste-goma-finalizado': data.diff > 2 ? true : false,
            'teste-goma-tear': data.diff <= 2 ? true : false
        }
    }

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData[props.field]);
    }

    useEffect(() => {
        let copy = [...data.producoes];
        let labels = [];
        let datasets = [];
        let data_trama = [];
        let data_urdume = [];

        copy.forEach((item) => {
            let index = labels.findIndex((element) => {
                return item.rolo === element;
            });

            if(index === -1 && item.rolo !== undefined && item.rolo !== '') {
                labels.push(item.rolo);
                data_trama.push(item.trama_cmpx);
                data_urdume.push(item.urdume_cmpx);
            }
        });

        datasets.push({
            label: "Trama CMPX",
            data: data_trama,
            backgroundColor: "#3498db"
        });

        datasets.push({
            label: "Urdume CMPX",
            data: data_urdume,
            backgroundColor: "#e67e22"
        });

        const chartData = {
            labels: labels,
            datasets: datasets
        }

        setChartData(chartData);
    }, [data]);

    return (
        <div>
            <Panel
                collapsed
                header="RELATÓRIO POR ROLO"
                toggleable
            >
                <DataTable
                    className="p-m-2"
                    rowClassName={rowColor}
                    size="small"
                    value={data.producoes}
                >
                    <Column header="Rolada" field="roladaf" style={options} />
                    <Column header="Tear" field="tear" style={options} />
                    <Column header="Rolo" field="rolo" style={options} />
                    <Column header="Data Entrada" field="dataentrada" style={options} />
                    <Column header="Data Saída" field="datasaida" style={options} />
                    <Column header="(m)" field="metros" style={options} body={(rowData) => {
                        return parseInt(rowData.metros)
                    }} />
                    <Column header="Eficiência" field="eficiencia_tear" style={options} body={(rowData) => {
                        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.eficiencia_tear) + "%"
                    }} />
                    <Column header="Urdume" field="urdume" style={options} />
                    <Column header="Trama" field="trama" style={options} />
                    <Column header="Urdume CMPX" field="urdume_cmpx" body={formatNumber} style={options} />
                    <Column header="Trama CMPX" field="trama_cmpx" body={formatNumber} style={options} />
                    <Column header="Quebras CMPX" field="quebras_cmpx" body={formatNumber} style={options} />
                </DataTable>
            </Panel>

            <Panel
                collapsed
                header="RELATÓRIO POR ROLO / DATA"
                toggleable
            >
                <DataTable
                    className="p-m-2"
                    rowClassName={rowColor}
                    size="small"
                    value={data.rolos_data}
                >
                    <Column header="Rolada" field="roladaf" style={options} />
                    <Column header="Tear" field="tear" style={options} />
                    <Column header="Rolo" field="rolo" style={options} />
                    <Column header="Data" field="dataf" style={options} />
                    <Column header="(m)" field="metros" style={options} body={(rowData) => {
                        return parseInt(rowData.metros)
                    }} />
                    <Column header="Eficiência" field="eficiencia_tear" style={options} body={(rowData) => {
                        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.eficiencia_tear) + "%"
                    }} />
                    <Column header="Urdume" field="urdume" style={options} />
                    <Column header="Trama" field="trama" style={options} />
                    <Column header="Urdume CMPX" field="urdume_cmpx" body={formatNumber} style={options} />
                    <Column header="Trama CMPX" field="trama_cmpx" body={formatNumber} style={options} />
                    <Column header="Quebras CMPX" field="quebras_cmpx" body={formatNumber} style={options} />
                </DataTable>
            </Panel>

            <Panel
                collapsed
                header="GRÁFICO DE QUEBRAS"
                toggleable
            >
                <Chart 
                    data={chartData}
                    height="650px"
                    width="100%"
                    options={chartOptions}
                    plugins={[ChartDataLabels]}
                    type="bar"
                />
            </Panel>
        </div>
    )
}